import React, {
  useState,
  useEffect,
  FunctionComponent,
  ReactNode,
  ReactElement,
} from 'react';
import Select, { StylesConfig, components } from 'react-select';
import { Option } from '../../admin-dashboard-tables/interfaces';

const selectStyles: StylesConfig<any, false> = {
  container: (provided) => ({
    ...provided,
    // minWidth: 240,
  }),
  control: () => ({}),
  menu: () => ({ boxShadow: 'inset 0 1px 0 rgba(0, 0, 0, 0.1)' }),
};

interface Props {
  options: Array<Option>,
  hideSearch: boolean,
  value: Option,
  setValue: (value: Option) => void,
  useValueAsLabel?: boolean,
  buttonLabel: string,
  Icon?: React.JSXElementConstructor<any>|ReactElement,
}

const Menu: React.FC<any> = (props) => {
  const shadow = 'hsla(218, 50%, 10%, 0.1)';
  return (
    <div
      style={{
        backgroundColor: 'white',
        borderRadius: 4,
        boxShadow: `0 0 0 1px ${shadow}, 0 4px 11px ${shadow}`,
        position: 'absolute',
        zIndex: 2,
      }}
      {...props}
    />
  );
};
const Blanket: React.FC<any> = (props) => (
  <div
    style={{
      bottom: 0,
      left: 0,
      top: 0,
      right: 0,
      position: 'fixed',
      zIndex: 1,
    }}
    {...props}
  />
);
interface DropdownProps {
  readonly isOpen: boolean;
  readonly target: ReactNode;
  readonly onClose: () => void;
}
const Dropdown: FunctionComponent<DropdownProps> = ({
  children,
  isOpen,
  target,
  onClose,
}) => (
  <div>
    {target}
    {isOpen ? <Menu>{children}</Menu> : null}
    {isOpen ? <Blanket onClick={onClose} /> : null}
  </div>
);

const Control = ({ children, selectProps, ...props }) => (
  // @ts-ignore
  <components.Control {...props}>
    {selectProps?.hideSearch
      ? (<></>)
      : children}
  </components.Control>
);

const ButtonDropDown: React.FC<Props> = ({
  options,
  hideSearch,
  setValue,
  value,
  useValueAsLabel,
  buttonLabel,
  Icon,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (!isOpen) {
      setValue({
        label: '',
        value: '',
      });
    }
  }, [isOpen]);

  const onSelectChange = (selected: Option) => {
    setIsOpen(!isOpen);
    setValue(selected);
  };

  return (
    <Dropdown
      isOpen={isOpen}
      onClose={() => setIsOpen(!isOpen)}
      target={(
        <button
          className="btn btn-primary d-flex align-items-center border-blue-600 button-shadow"
          onClick={() => setIsOpen(!isOpen)}
        >
          {Icon}
          <span className="ml-1 action-font bulk-label text-uppercase">
            {
              (useValueAsLabel && !!value?.label)
                ? value.label
                : buttonLabel
            }
          </span>
        </button>
      )}
    >
      <Select
        autoFocus
        isSearchable={false}
        backspaceRemovesValue={false}
        // TODO: Figure out how to remove Search Box
        components={{
          Control,
        }}
        hideSearch={hideSearch}
        controlShouldRenderValue={false}
        hideSelectedOptions={false}
        isClearable={false}
        menuIsOpen
        onChange={onSelectChange}
        options={options}
        placeholder="Search..."
        styles={selectStyles}
        tabSelectsValue={false}
        value={value}
      />
    </Dropdown>
  );
};

ButtonDropDown.defaultProps = {
  buttonLabel: 'Select...',
  Icon: (<></>),
};

export default ButtonDropDown;
